export default function(value) {
	const lookup = {
		ou: "Organisational Unit",
		ou_path: "Organisational Unit membership",
		group_membership: "Group membership",
		class_membership: "Class membership"
	};

	return lookup[value] ? lookup[value] : value;
}
